import { ChangeEvent, FC, useState, useEffect } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { DMSBatchesActions } from 'app/store/DMSBatches/DMSBatches.slice';
// Selectors
import { selectFilter } from 'app/store/DMSBatches/DMSBatches.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import { Input } from 'app/components/Mui';
// Hooks
import useDebounce from 'app/hooks/useDebounce';
// i18next
import { useTranslation } from 'react-i18next';

const BatchesFilter:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const filter = useAppSelector(selectFilter);

  const [ stateFilter, setStateFilter ] = useState(filter);

  const debounceSearch = useDebounce(stateFilter.search);

  useEffect(() => {
    if ( debounceSearch !== filter.search ){
      dispatch(DMSBatchesActions.setFilter({ field: 'search', value: debounceSearch }));
    }
    // eslint-disable-next-line
  }, [debounceSearch]);

  const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setStateFilter((prevState:any) => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleClearSearch = () => {
    setStateFilter((prevState:any) => ({
      ...prevState,
      search: ''
    }));
  }

  return (
    <Box sx={{ p: 4, pb: 2 }}>
      <Input
        label={t('labels.search')} name="search" value={stateFilter.search}
        placeholder={t('form.placeholder.nameOrLabel')}
        onChange={handleChange}
        onClear={handleClearSearch}
        autoComplete="off"
        margin="none"
        size="small"
      />
    </Box>
  )
}

export default BatchesFilter;
